/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your JSON here…`)
};

const es_jf_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega tu JSON aquí…`)
};

const de_jf_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie hier Ihr JSON ein…`)
};

const nl_jf_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak je JSON hier…`)
};

const fr_jf_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez votre JSON ici…`)
};

const it_jf_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla il tuo JSON qui…`)
};

const pt_br2_jf_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole seu JSON aqui…`)
};

const pt_jf_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole o seu JSON aqui…`)
};

const ja_jf_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONをここに貼り付けてください…`)
};

const zh_jf_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在此粘贴您的 JSON…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_placeholder", locale)
	if (locale === "en") return en_jf_placeholder(inputs)
	if (locale === "es") return es_jf_placeholder(inputs)
	if (locale === "de") return de_jf_placeholder(inputs)
	if (locale === "nl") return nl_jf_placeholder(inputs)
	if (locale === "fr") return fr_jf_placeholder(inputs)
	if (locale === "it") return it_jf_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_jf_placeholder(inputs)
	if (locale === "pt") return pt_jf_placeholder(inputs)
	if (locale === "ja") return ja_jf_placeholder(inputs)
	return zh_jf_placeholder(inputs)
};